import React from 'react';
import { Text } from '@visx/text';
import { Line } from '@visx/shape';
import { Group } from '@visx/group';

const TrendLimits = ({ limits, scale, xMax, yMax, unit = '', hideLimitLabels = false }) => {
  const [start, stop] = scale.domain();

  const Limits = limits
    // This is a work around for when sensor data are exactly ONLY the same as one of the limimts.
    // if scale domain is, say [5,5], and one of the limits is exactly that, use only that one.
    .filter(({ limit }) => !(start === stop && limit !== start))
    .map(({ limit, severity }) => {
      const posY = scale(limit);
      const labelText = `${limit.toFixed(1)} ${unit}`;
      // Estimate text width: ~7px per character for this font size
      const textWidth = labelText.length * 7;
      const isHidden = posY < 0 || posY > yMax;

      // Don't render if outside visible area
      if (isHidden) return null;

      return (
        <Group className="trend__limits" key={severity}>
          <Line
            className="trend__limits-line"
            from={{ x: 0, y: posY }}
            to={{ x: xMax, y: posY }}
            strokeDasharray="6,4"
            stroke="#FFFFFF"
            strokeOpacity="0.2"
            strokeWidth="1"
          />

          {!hideLimitLabels && (
            <>
              <Text
                className="trend__limits-text"
                x={xMax + 10}
                y={posY}
                verticalAnchor="middle"
              >
                {labelText}
              </Text>
              <use
                x={xMax + 12 + textWidth}
                y={posY - 7}
                href={`#${severity}`}
                width="14"
                height="14"
              />
            </>
          )}
        </Group>
      );
    }).filter(Boolean);

  return Limits;
};

export default React.memo(TrendLimits);
/* export default React.memo(TrendLimits); */
